import AppSettings from "../../../../Settings/AppSettings";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../Context/AppContext";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import LoadingSuccessErrorAlert from "../../Rules/Components/LoadingSuccessErrorAlert";
import Label from "../../../Common/components/Label";
import { toast } from "react-toastify";
import GMSButton from "../../../Common/components/GMSButton";
import GMSFillButton from "../../../Common/components/GMSFillButton";

const Validate = ({ modalValidateClose, type = null, ruleId=null, compatibilityLevel= '', fetchData }) => {
  const appData = useContext(AppContext);
  const channelKey = appData?.channelKey;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({status: "", message: "", });
  const [downloadUrl, setDownloadUrl] = useState(null);
  let [psStatus, setPsStatus] = React.useState([]);
  let [selectedFile, setSelectedFile] = React.useState(null);

 async function handle_file_selection(event) {
    event.preventDefault();
    const file = event.target.files[0];
    const totalCount = await appData.checkSelectedFile(file,file.type);
    if (totalCount > 0) {
      setSelectedFile(file); 
    } else{ 
      setSelectedFile(null); 
    }
  }

  // delete selected file
  async function handleFileDelete(event) {
    event.preventDefault();
    if(selectedFile != null) setSelectedFile(null)
  }

  async function do_upload_pdw() {
    setLoading({
      status: "Loading",
      message: "File uploading....",
    });
    const formData = new FormData();
    formData.append("file", selectedFile);
    const url = type === "CBM" ? `rule/validate_file/${ruleId}?compat_level=${compatibilityLevel}` :`pdw/upload/validateproducts/${channelKey}`
    const res = await ServiceWrapper.doPost(
      api_base_url + url,
      formData,
      null,
      AuthManager.getGmsToken(),
      true
    );

    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({
          status: "Loading",
          message: res.data.message,
        });
        setTimeout(() => {
          checkUploadStatus(type === "CBM" ? res?.data?.job_id : res.data.jobid);
        }, 2000);
      } else {
        toast.error(res.data.message);
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      toast.error("Error in updating");
      setLoading({
        status: "Error",
        message: "Error Updating ",
      });
    }
    functionThatResetsTheFileInput();
    setSelectedFile(null);
  }

  const checkUploadStatus = async (jobId) => {
    try {
        if (!jobId) {
            toast.error("Job Id not found");
            setLoading({ status: "Error", message: "JobId not found" });
            return;
        }

        const jobStatusResponse = await ServiceWrapper.doGet(api_base_url + "job/status/" + jobId, null, null, AuthManager.getGmsToken());

        if (jobStatusResponse.errorfound) return;

        if (jobStatusResponse.data.processing) {
            setLoading({ status: "Loading", message: jobStatusResponse.data.status });
            setTimeout(() => { checkUploadStatus(jobId); }, 2000);
            return;
        }

        if (jobStatusResponse.data.error) {
            toast.error(jobStatusResponse.data.status);
            setLoading({ status: "Error", message: jobStatusResponse.data.status });
            return;
        }
        setLoading({ status: "", message: '' });

        const toastMessage = type === "CBM" ? jobStatusResponse?.data?.message : jobStatusResponse?.data?.status;
        const downloadUrl = type === "CBM" ? jobStatusResponse?.data?.data : jobStatusResponse?.data?.data?.url;

        toast.success(toastMessage);
        setDownloadUrl(downloadUrl);

    } catch (error) {
        console.error("checkUploadStatus ~ error:", error);
    }
  };

  useEffect(() => {
    if (downloadUrl) {
      const timer = setTimeout(() => {
        setDownloadUrl(undefined);
        modalValidateClose();
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [downloadUrl]);

  

  const [inputKey, setInputKey] = useState("");
  const functionThatResetsTheFileInput = () => {
    let randomString = Math.random().toString(36);
    setInputKey(randomString);
  };
  return (
    <div className="ps-0 pe-3">
      <div className="border p-5 cursor-pointer">
        <div>
          <label
            className="upload-area cursor-pointer"
            style={{
              width: "100%",
              textAlign: "center",
              color: "#091caa",
            }}
          >
            <input
              type="file"
              id="fupload"
              style={{ display: "none" }}
              key={inputKey || ""}
              onChange={(event) => handle_file_selection(event)}
              onClick={(event) =>  event.target.value = null}
            />
            <i className="fa fa-cloud-upload fa-x"></i>
            <br />
            {/* <p style={{ fontSize: "0.75", color: "#c9c9cf" }}>
              (Note: Only <strong>".xlsx"</strong> files are allowed to upload)
            </p> */}
            <Label
              message="(Note: Only .xlsx files are allowed to upload)"
              fontSize={0.75}
              color={"#172B4D"}
            />
            <br />
            <strong>Browse File</strong>
          </label>
          <br />
          <span
            className="mt-2 w-100"
            style={{
              display: "block",
              width: "100%",
              textAlign: "center",
              wordWrap: "break-word",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {selectedFile && selectedFile.name}
          </span>
        </div>
      </div>

      <div className="d-flex mt-3 justify-content-between w-100" style={{ float: "right" }}>
        <GMSButton 
        name="Delete" 
        disabled={!selectedFile} 
        className={"btn btn-outline-danger focus:outline-none active:scale-96 "} 
        onClick={handleFileDelete} 
        />

        <div className="d-flex">
          <GMSButton name="Cancel" onClick={() => modalValidateClose()} />
          &nbsp;&nbsp;&nbsp;
          <GMSFillButton
            name="Save"
            disabled={!selectedFile}
            onClick={() => do_upload_pdw()}
            />
        </div>
      </div>
      <br />
      <br />
      <br />

      <div className="mt-2">
        <LoadingSuccessErrorAlert loading={Loading} hide_error={true}/>
      </div>
      <iframe
        style={{ display: "none" }}
        src={downloadUrl}
        id="iframe_pdw_download"
        title="Validate PDW"
      />

      {psStatus.map((item, index) => (
        <React.Fragment key={index + "pdw_upload_sttaus"}>
          {item !== null && (
            <>
              <div className="alert alert-primary" role="alert">
                {index === psStatus.length - 1 && (
                  <span className="fas fa-circle-notch fa-spin" />
                )}
                {index !== psStatus.length - 1 && (
                  <span className="fas fa-check-circle" />
                )}
                &nbsp;
                {<strong>{item}</strong>}
              </div>
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
export default Validate;